(function () {
	const HOST_SEL = '.wp-block-group.is-style-hh-expandable-hero-host';
	const TOGGLE_SEL = '.wp-block-button.is-style-hh-expandable-hero-toggle';
	const OPEN_CLASS = 'hh-expandable-hero-is-open';
	const DATA_ORIGINAL_LABEL = 'data-hh-expandable-original-label';
	const COLLAPSE_LABEL = 'Einklappen';

	function initAria() {
		document.querySelectorAll(HOST_SEL).forEach((host) => {
			const toggles = host.querySelectorAll(`${TOGGLE_SEL} a, ${TOGGLE_SEL} button`);
			const open = host.classList.contains(OPEN_CLASS);
			toggles.forEach((el) => {
				if (!el.hasAttribute('aria-expanded')) {
					el.setAttribute('aria-expanded', open ? 'true' : 'false');
				}
			});
		});
	}

	function applyToggleLabel(interactive, willOpen) {
		if (willOpen) {
			if (!interactive.hasAttribute(DATA_ORIGINAL_LABEL)) {
				const raw = interactive.textContent.trim();
				interactive.setAttribute(DATA_ORIGINAL_LABEL, encodeURIComponent(raw));
			}
			interactive.textContent = COLLAPSE_LABEL;
			return;
		}
		const stored = interactive.getAttribute(DATA_ORIGINAL_LABEL);
		if (stored === null || stored === '') {
			return;
		}
		try {
			interactive.textContent = decodeURIComponent(stored);
		} catch {
			interactive.textContent = stored;
		}
	}

	function scrollHostIntoViewAfterCollapse(host) {
		const inner = host.querySelector(
			'.is-style-hh-expandable-hero-inner .wp-block-group__inner-container'
		);
		let done = false;
		const finish = () => {
			if (done) {
				return;
			}
			done = true;
			const reduceMotion =
				window.matchMedia &&
				window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			host.scrollIntoView({
				behavior: reduceMotion ? 'auto' : 'smooth',
				block: 'start',
			});
		};
		if (!inner) {
			window.requestAnimationFrame(finish);
			return;
		}
		const onEnd = (ev) => {
			if (ev.propertyName !== 'max-height') {
				return;
			}
			inner.removeEventListener('transitionend', onEnd);
			finish();
		};
		inner.addEventListener('transitionend', onEnd);
	}

	document.addEventListener('click', (e) => {
		const interactive = e.target.closest(`${TOGGLE_SEL} a, ${TOGGLE_SEL} button`);
		if (!interactive) {
			return;
		}
		const host = interactive.closest(HOST_SEL);
		if (!host) {
			return;
		}

		if (interactive.tagName === 'A') {
			const hrefAttr = interactive.getAttribute('href');
			if (hrefAttr != null && hrefAttr !== '' && hrefAttr !== '#') {
				return;
			}
			e.preventDefault();
		}

		const willOpen = !host.classList.contains(OPEN_CLASS);
		applyToggleLabel(interactive, willOpen);
		host.classList.toggle(OPEN_CLASS, willOpen);
		interactive.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
		if (!willOpen) {
			scrollHostIntoViewAfterCollapse(host);
		}
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAria);
	} else {
		initAria();
	}
})();
